import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setPageName } from '../reducers/pageSlice';
import { fetchDataCollections } from '../reducers/dataCollectionSlice';
import TabFactory from '../components/tabs/TabFactory';
import { tabSlice } from '../reducers/notifications/tabs';

const DATA_COLLECTIONS_URL = '/api/dataCollections';
function Notifications() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageName('Notifications'));
    dispatch(
      fetchDataCollections({
        url: DATA_COLLECTIONS_URL,
        method: 'GET',
      })
    );
  }, []);

  return <TabFactory slice={tabSlice} />;
}

export default Notifications;
